import LandingPageBanner from '@/components/LandingPageBanner/LandingPageBanner';
import PressKitCategories from './data/categories';
import { Variants, motion } from 'framer-motion';
import { useRef } from 'react';
import Link from 'next/link';
import { Text, Title } from '@mantine/core';
import Image from 'next/image';
import { useRouter } from 'next/router';

export default function PressKitView() {
  const scrollRef = useRef(null);
  const itemMotion: Variants = {
    hidden: { opacity: 0, y: 50 },
    show: {
      transition: {
        mass: 1,
        duration: 0.6,
        type: 'tween',
      },
      opacity: [0, 0.2, 0.3, 0.5, 1],
      y: 0,
      height: '100%',
    },
  };

  const categories = PressKitCategories;
  const router = useRouter();

  const locale = router.locale || 'pt-BR';

  return (
    <div className="bg-['#1A1B1E'] m-auto">
      <LandingPageBanner
        isBlogDetail
        title={'Press Kit'}
        banner={'/press-kit/banners/BANNER PRINCIPAL PRESS KIT.png'}
      />

      <div className="max-w-[82.5rem] m-auto px-[20px] py-[60px] gap-[45px] grid sm:grid-cols-auto-fit-minmax grid-cols-1">
        {categories.map((category) => (
          <motion.div
            key={category.key}
            initial="hidden"
            whileInView="show"
            variants={itemMotion}
            viewport={{ root: scrollRef, once: true }}
          >
            <Link className="w-full h-full" href={`/press-kit/${category.key}`}>
              <div className="hover:scale-105 hover:brightness-90 bg-black bg-opacity-40 rounded-lg overflow-hidden backdrop-blur-sm w-full h-full no-underline transition-all duration-200">
                <div className="relative w-full aspect-[16/9]">
                  <Image src={category.image} alt="" fill style={{ objectFit: 'cover' }} />
                </div>
                <div className="flex flex-col gap-[15px] p-[20px]">
                  <Title order={2} className="text-[#cecece] text-lg font-bold" lh={1.3}>
                    {category.title[locale]}
                  </Title>
                  <Text fz={16} fw="400">
                    {category.description[locale]}
                  </Text>
                </div>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
